// extracted by mini-css-extract-plugin
module.exports = {"content":"style_content__3VxGw","card":"style_card__3YDaA","image":"style_image__b_2ie","name":"style_name__1lg2d","button":"style_button__2KpCb"};